module.exports = __webpack_public_path__ + "static/media/chorthippus_pullus_001_APA.5f57cd84.png";